import Vue from 'vue'
import Vuex from 'vuex'
import user from './user';
import homeBar from './modules/homeBar'
import {defaultStyleTp} from "@/js/constants";
import VuexPersist from 'vuex-persist';
Vue.use(Vuex)

// 检查是否是静默登录
const isSilentLogin = window.location.search.includes('token=') && 
                      window.location.search.includes('path=')

// 静默登录时不恢复持久化数据
const vuexPersist = new VuexPersist({
  key: 'my-app-v1.2.116',
  storage: window.sessionStorage,
  restoreState: isSilentLogin ? () => ({}) : undefined, // 静默登录时返回空对象
});

const store = new Vuex.Store({
    state: {
        name: '',
        userId: '',
        ref: '',
        username: '',
        deptId: '',
        password: '',
        sendVideoId: '',
        deptStatus: '',
        serve: [],
        selectFireBookActive: 'first',
        smokeAlarmActive: 1,
        canOper: true,
        onlyShowSecond: false,
        hostId: '',
        subRep: true,
        isShow: false,
        alarmDialogOpen: true,
        sdkUserName: '', //狮子王的sdk的账号
        generalizeList:null,// 设备总量
        sdkObj:{},
        deviceIp: '',
        deviceNum: '',
        // 特殊部门使用homeChannel首页 为0时保持不变
        teShuBuMen: '0',
        styleTp: defaultStyleTp // 控制页面样式显示
    },
    mutations: {
        updateSdkObj(state,sdkSign,){
            state.sdkObj = sdkSign
        },
        updateOnlyShowSecond(state, onlyShowSecond) {
            state.onlyShowSecond = onlyShowSecond;
        },
        updateCanOper(state, canOper) {
            state.canOper = canOper;
        },
        updateSmokeAlarmActive(state, smokeAlarmActive) {
            state.smokeAlarmActive = smokeAlarmActive;
        },
        updateSelectFireBookActive(state, selectFireBookActive) {
            selectFireBookActive = selectFireBookActive;
        },
        clearLoginInfo(state) {
            state.name = '';
            state.userId = '';
            state.ref = '';
            state.deptStatus = '';
            // this.store=JSON.stringify(null);
            // sessionStorage.removeItem("store");
            // window.addEventListener("beforeunload", () => {
            //     sessionStorage.setItem("store", null);
            // });
        },
        updateAlarmDialogOpen(state, nowStatus) {
            state.alarmDialogOpen = nowStatus
        },
        updateGeneralizeList(state,value){
            state.generalizeList = value
        },
        updateStyleTp (state, value) {
          state.styleTp = value
        }
    },
    modules:{
        user,
        homeBar
    },
    plugins: [vuexPersist.plugin],
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js